import { useEffect, useState } from 'react';

import { NotificationItemProps as NotificationItem } from 'types/api/notification.type';
import { ProductType } from 'types/api/product.type';

import { useAppSelector } from 'redux/hooks';

import { notificationDataService } from 'services/notification.service';

const useNotification = (data?: ProductType) => {
  const [notificationsDetails, setNotificationsDetails] = useState<NotificationItem[]>([]);
  const [notificationModalVisible, setNotificationModalVisible] = useState(false);
  const { season, marketLine } = useAppSelector((state) => state.settings);

  const getNotificationData = () => {
    if (!data) return;
    notificationDataService
      .getProductNotifications({
        itemCode: data.itemCode,
        mainFabricCode: data.mainFabricCode,
        season,
        seasonLine: marketLine,
      })
      .then((res) => {
        setNotificationsDetails(res.data);
      });
  };

  const showNotificationModal = () => {
    setNotificationModalVisible(true);
  };
  const hideNotificationModal = () => {
    setNotificationModalVisible(false);
  };

  useEffect(() => {
    getNotificationData();
  }, [data]);

  return {
    showNotificationModal,
    hideNotificationModal,
    notificationModalVisible,
    notificationsDetails,
  };
};

export { useNotification };
